import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || ""
};

const isFirebaseConfigured = Object.values(firebaseConfig).every((value) => value);

if (!isFirebaseConfigured) {
  console.error(
    "Firebase is not configured. Create a .env file using .env.example and set the REACT_APP_FIREBASE_* values."
  );
}

let app = null;
let auth = null;
let googleProvider = null;

if (isFirebaseConfigured) {
  app = initializeApp(firebaseConfig);
  auth = getAuth(app);
  googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({ prompt: 'select_account' });
} else {
  // Avoid calling initializeApp with missing/empty keys which causes
  // a runtime FirebaseError: auth/invalid-api-key. Export nulls so
  // consuming code can handle absence of Firebase config gracefully.
}

export { auth, googleProvider };
